import {
  AlertDialog,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog';
import { Button } from '@/components/ui/button';

import { useTOTP } from '../model';

const AlertDisableTOTPDialog = () => {
  const { disableAlertOpen, disableTOTP, cancel } = useTOTP();

  return (
    <AlertDialog open={disableAlertOpen} onOpenChange={cancel}>
      <AlertDialogContent className="sm:max-w-[512px]">
        <AlertDialogHeader>
          <AlertDialogTitle>Are you sure you want to disable multi-factor authentication?</AlertDialogTitle>
          <AlertDialogDescription>
            Disabling multi-factor authentication reduces your account security and may conflict with your
            organization&apos;s security policy.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>Cancel</AlertDialogCancel>
          <Button variant="destructive" onClick={disableTOTP}>
            Disable
          </Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export default AlertDisableTOTPDialog;
